export default __webpack_public_path__ + "static/media/partenariat.7064d5f1.jpg";